import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import {
  TRANSLATIONS_ASSET_PREFIX,
  TRANSLATIONS_ASSET_SUFFIX,
  TRANSLATIONS_CACHE_VERSION,
  translationsCacheKey,
} from './i18n.config';

@Injectable()
export class CachedTranslateLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string): Observable<TranslationObject> {
    const cacheKey = translationsCacheKey(lang);
    const url = `${TRANSLATIONS_ASSET_PREFIX}${lang}${TRANSLATIONS_ASSET_SUFFIX}?v=${TRANSLATIONS_CACHE_VERSION}`;

    return this.http.get<TranslationObject>(url).pipe(
      tap(translations => {
        try {
          localStorage.setItem(cacheKey, JSON.stringify(translations));
        } catch {
          // Ignore quota errors — HTTP translations still work.
        }
      }),
      catchError(() => {
        const cached = localStorage.getItem(cacheKey);

        if (cached) {
          try {
            return of(JSON.parse(cached) as TranslationObject);
          } catch {
            localStorage.removeItem(cacheKey);
          }
        }

        return throwError(() => new Error(`Unable to load translations for ${lang}`));
      }),
    );
  }
}
